import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {NoteAddDialogData} from "../../note/note-add-dialog/note-add-dialog.component";

@Component({
  selector: 'app-warehouse-product-add-dialog',
  templateUrl: './warehouse-product-add-dialog.component.html',
  styleUrls: ['./warehouse-product-add-dialog.component.scss']
})
export class WarehouseProductAddDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<WarehouseProductAddDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: NoteAddDialogData
  ) { }

  ngOnInit(): void {
  }

  closeDialog(e): void {
    this.dialogRef.close(e);
  }

}
